var exports = {
  "OK": "HeaderGrid__erNVbQ",
  "wn": "Section__Z72tHh",
  "w": "SectionHeading__NgK2XI",
  "qi": "CommitInput__p_BAcB",
  "LU": "ReasonControls__ETmCyu",
  "OQ": "OtherReasonContainer__K3Xv4d",
  "tj": "CommitItem__lrztoS",
};

module.exports = exports;
